import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[var(--bg-dark)] text-stone-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img src="/artfutur-mixed-white.png" alt="ArtFutur" className="h-16 w-auto object-contain mb-4" />
          <p className="text-sm text-stone-400 leading-relaxed max-w-xs">
            A global peer-to-peer marketplace connecting artists with collectors. You're paid the moment your work is delivered.
          </p>
        </div>
        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-stone-500 mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/gallery" className="hover:text-[var(--gold)] transition-colors">Gallery</Link></li>
            <li><Link to="/trade" className="hover:text-[var(--gold)] transition-colors">Trade & Designers</Link></li>
            <li><Link to="/how-it-works" className="hover:text-[var(--gold)] transition-colors">How It Works</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-stone-500 mb-4">For Artists</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/sell" className="hover:text-[var(--gold)] transition-colors">Sell your art</Link></li>
            <li><Link to="/login" className="hover:text-[var(--gold)] transition-colors">Artist dashboard</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-stone-500 mb-4">Buyers</h4>
          <ul className="space-y-2.5 text-sm">
            <li>Retail collectors</li>
            <li>Fine art investors</li>
            <li>Hotels, venues & designers</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-stone-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} ARTFUTUR.COM — Global Fine Art Marketplace.</span>
          <span className="font-mono">Paid to the artist on delivery</span>
        </div>
      </div>
    </footer>
  );
}
